<template>
  <div class="total-turnover">
    <h3>没有后续页面额，给您添加了<span>数据说明:</span></h3>
    <div class="red box">
      <h3>总营业额=实际收入+虚收总额</h3>
      <p>注：不是真实收入。对账请和实际收入对账</p>
    </div>
    <div class="orange box">
      <h3>实际收入=桌台+商品+充值会员+比赛报名+预定+助教</h3>
      <p>注：只有真实付款的才算到实际收入里，会员支付台费则不算实际收入，算作虚收总额里。</p>
    </div>
    <div class="green box">
      <h3>虚收总额=会员结账+免单金额+销账金额</h3>
      <p>注：这项数据是新开发的，开发原因是，有会员卡支付台费，有朋友打球需要免单，或者因意外事故追单转销账的这三种特殊订单，都有结账但无现金收入，加一起方便看，因此创在了：虚收总额。以后再有就是抄袭啦。</p>
    </div>
    <div class="white box">
      <h3>追单金额=追账中的账单金额相加</h3>
      <p>注1：关灯来付款的成为追涨中的订单，简称【追单】</p>
      <p>注2：追单中的用户，无法在开启球台灯系列操作，除非您在追单中把他的帐销了。</p>
    </div>
    <div class="blessing">
      <p>我们（KO台球项目组），组里都喜欢热爱台球，想把台球事业认真的进行到底，专注思考解决台球事业上一切问题</p>
      <p>KO台球商户端：希望您用的舒心放心，能为您提高营业额，让商户省心省力</p>
      <p>KO台球用户端：希望感染更多年轻人，加入到台球云动力，让行业恢复年轻</p>
      <p>项目立项到上线，初心未改，努力加油，谢谢您的使用，我们与您携手前行</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.total-turnover{
  padding: 7px;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: left;
  line-height: 40px;
  h3{
    font-size: 20px;
    >span{
      color: #00FE99;
    }
  }
  .box{
    box-shadow: 2px 2px 10px #000 inset,-2px -2px 10px #000 inset;
    padding: 15px;
    border-radius: 2px;
    margin-bottom: 8px;
  }
  .red{
    background: #CC3030;
  }
  .orange{
    background: #D97D11;
  }
  .green{
    background: #7C7F16;
    color: #fff!important;
    >p{
      line-height: 20px;
    }
    padding-bottom: 10px;
  }
  .white{
    background: #fff;
    color: #FF4E4E;
    >p{
      line-height: 20px;
    }
    padding-bottom: 10px;
    margin-bottom: 40px;
  }
  .blessing{
    line-height: 20px;
    font-size: 14px;
    padding-left: 20px;
    >:nth-child(3){
      margin-bottom: 20px;
    }
  }
}
</style>